<script lang="ts">
	import {
		FAQ,
		EquityProtectionProgram,
		SellOptions,
		SubHeroMetrics,
		WhySellWithUs,
		QuickCashOffer,
		FreeQuote,
		HomePageHero
	} from "#lib/web-ui/home-buyers-template/content/index.js";
	import { getTemplateContext } from "#lib/web-ui/home-buyers-template/template-context.svelte.js";

	const templateContext = getTemplateContext();

	const heroTitle = `Multiple Options to Buy Your Home Fast`;
	const heroSubTitle = `${templateContext.siteName} has multiple options to buy your home fast. We pay cash fast and close on your timeline.`;
</script>

<HomePageHero title={heroTitle} subTitle={heroSubTitle} />
<SubHeroMetrics />
<SellOptions />
<QuickCashOffer />
<EquityProtectionProgram />
<WhySellWithUs />
<FreeQuote />
<FAQ />
